import { mapGetters } from 'vuex'
import Add from './add.dialog.vue'
import announcement from '../../../../api/announcement'
import SiteSearchGroup from '@/components/search-group'
import help from '@/utils/help'
const columns = [
  {
    title: '',
    enTitle: 'Name',
    width: 350,
    dataIndex: 'name'
  },
  {
    title: '',
    enTitle: 'View in Total',
    width: 120,
    sort: true,
    dataIndex: 'readNum'
  },
  {
    title: '',
    enTitle: 'Publish Date',
    width: 100,
    sort: true,
    dataIndex: 'firstReleaseTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Operation Time',
    width: 150,
    dataIndex: 'updateTime',
    slot: 'time',
    sort: true
  },
  {
    title: '',
    enTitle: 'Status',
    width: 120,
    dataIndex: 'released',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    Add,
    SiteSearchGroup
  },
  data() {
    return {
      columns,
      isVisable: false,
      dataSource: [],
      inputData: {},
      params: {
        released: '',
        name: '',
        sorted: ''
      },
      publishedDate: [],
      showHandleDate: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      journalId: 'getJournalId',
      user: 'getUser'
    })
  },
  watch: {
    journalId: {
      handler() {
        this.getList()
      },
      immediate: true
    }
  },
  mounted() {
    help.closeAutocomplete()
  },
  methods: {
    async getList() {
      if (!this.journalId) {
        return
      }
      const data = Object.assign(this.params, { journalId: this.journalId })
      this.dataSource = await announcement.getAll(data)
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    },
    changeStatus(status) {
      this.params.released = status
      this.getList()
    },
    add() {
      this.inputData = {}
      this.isVisable = true
    },
    edit(val) {
      this.inputData = val
      // this.$refs['database-add'].getQuery(val.id)
      this.isVisable = true
    },
    async able(val) {
      const { id, released, version } = val
      await announcement.release(id, !released, { version })
      let content = 'This Announcement has been published!'
      if (released) {
        content = 'This Announcement has been unpublished!'
      }
      this.$message.success({
        title: 'Success',
        content: content
      })
      this.getList()
    },
    del(val) {
      this.$confirm({
        title: 'Are you sure you want to delete this Announcement?',
        content:
          'Please be aware of once this Announcement is deleted, it will never be able to recovered.',
        type: 'danger',
        icon: 'iconDelete'
      }).then(async () => {
        await announcement.del(val.id)
        this.$message.success({
          title: 'Success',
          content: 'This Announcement has been deleted!'
        })
        this.getList()
      })
    },
    async setSort(val) {
      val.forEach((item, index) => {
        item.sort = index
      })
      await announcement.setSort(val)
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
    },
    handleClear() {
      this.params.name = ''
      this.params.firstReleaseTimeStart = ''
      this.params.firstReleaseTimeEnd = ''
      this.publishedDate = []
      this.getList()
    },
    publishedDateChange(date) {
      this.params.firstReleaseTimeStart = date[0] ? date[0].startOf('d') : ''
      this.params.firstReleaseTimeEnd = date[1] ? date[1].endOf('d') : ''
      this.getList()
    }
  }
}
